import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch social list data
export const getSocialDetailList = createAsyncThunk(
  "socialDetailList/getSocialDetailList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/setting/social`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const socialDetailSlice = createSlice({
  name: "socialDetailList",
  initialState: {
    loading: false,
    socialDetailData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSocialDetailList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSocialDetailList.fulfilled, (state, action) => {
        state.loading = false;
        state.socialDetailData = action.payload;
      })
      .addCase(getSocialDetailList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default socialDetailSlice.reducer;
